import React from "react";
import { Button } from "../ui/button";
import { getAuthenticatedPages, getRoutes } from "@/utils/helpers";
import { useNavigate } from "react-router-dom";
import { Brand } from "@/types/brand";

interface Props {
  data: Brand[] | undefined;
}

const Brands: React.FC<Props> = ({ data: brands }) => {
  const isBrandsPage = getAuthenticatedPages().brands;
  const navigate = useNavigate();
  const routes = getRoutes();

  const onBrandClick = (bid: string) => {
    navigate(routes.brand(bid));
  };

  return (
    <div className="w-full rounded-lg border border-gray-200 p-6">
      {!isBrandsPage && (
        <div className="flex items-center justify-between">
          <div className="flex flex-col gap-1.5 mb-8">
            <h3 className="text-2xl font-semibold">Brands</h3>
            <p className="text-primary">Manage your brands</p>
          </div>
          <div>
            <Button
              variant="link"
              className="text-primary"
              onClick={() => navigate(routes.brands)}
            >
              View all
            </Button>
          </div>
        </div>
      )}
      <div className="flex gap-4 flex-wrap">
        {brands?.map((brand) => (
          <div
            key={brand.handle}
            className="flex flex-col items-center gap-4 p-10 border border-gray-300 cursor-pointer hover:bg-gray-50 rounded-lg w-50 h-60 transition-all duration-300 ease-in-out"
            onClick={() => onBrandClick(brand.id)}
          >
            <div className="flex-shrink-0 w-25 h-25 bg-gray-100 flex items-center justify-center rounded-full">
              {brand.logo_url ? (
                <img
                  src={brand.logo_url}
                  alt={brand.title.en}
                  className="w-full h-full object-cover rounded-full"
                />
              ) : (
                <span className="text-gray-500 text-3xl select-none">
                  {brand.title.en[0]}
                </span>
              )}
            </div>
            <div>
              <h3 className="text-lg font-semibold text-center">
                {brand.title.en}
              </h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default Brands;
